import React, { Component } from 'react'
import Select from 'react-select';
import Capsule from '../../common/components/Capsule';
import produce from "immer";
import withTranslation from "../../i18n/withTranslation";

class WycieczkaFakultatywna extends Component {
  handleTaskSelect = selectedTask => {
    const { handleChange, data } = this.props;
    const nextData = produce(data, draft => {
      draft.typ = selectedTask.value;
    });
    handleChange(nextData, true);
  }

  addUser = user => {
    const { handleChange, data } = this.props;
    const nextData = produce(data, draft => {
      draft.uzytkownicy.push(user);
    });
    handleChange(nextData);
  }

  removeAssignedUser = id => {
    const { handleChange, data } = this.props;
    const nextData = produce(data, draft => {
      draft.uzytkownicy = data.uzytkownicy.filter(user => user.id !== id);
    });
    handleChange(nextData);
  }

  availableUsers = () => {
    const { data, allUsers } = this.props;
    const userIds = data.uzytkownicy.map(user => user.id);
    return allUsers.filter(user => !userIds.includes(user.id));
  }

  handleInput = ev => {
    const { handleChange, data } = this.props;
    const nextData = produce(data, draft => {
      draft.dane[ev.target.id] = ev.target.value;
    });
    handleChange(nextData);
  }

  handleTripSelect = trip => {
    const { handleChange, data } = this.props;
    const nextData = produce(data, draft => {
      draft.dane.id = trip.value;
    });
    handleChange(nextData);
  }

  render() {
    const { data, allTasks, handleDestroy, allTrips } = this.props;
    return (
      <form id={`form-${data.id}`} className="form margin--top form-child" style={{ marginBottom: 20 }}>
        <span onClick={() => handleDestroy(data.id)} className="icon icon-close_icon"></span>
        <Select
          value={allTasks.find(option => option.value === data.typ)}
          options={allTasks}
          placeholder={this.props.t("taskForms.selectTask")}
          onChange={this.handleTaskSelect}
          isClearable={false}
        />
        <div className="margin--top">
          <Select
            value={data.dane.id && allTrips.find(option => option.value === data.dane.id)}
            isClearable={false}
            options={allTrips}
            className="margin--top"
            placeholder={this.props.t("taskForms.selectTrip")}
            onChange={this.handleTripSelect}
          />
        </div>
        <div className="margin--top" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
          <span className="margin--bottom">{this.props.t("taskForms.assigned")}</span>
          {data.uzytkownicy.map(user => <Capsule key={user.id} className="margin--left margin--bottom" id={user.id} text={user.imieNazwisko} onRemove={this.removeAssignedUser} />)}
          <Select
            options={this.availableUsers()}
            value={null}
            className="margin--left margin--bottom col-4 padding--remove"
            placeholder={this.props.t("taskForms.addPerson")}
            onChange={this.addUser}
          />
        </div>
      </form>
    )
  }
}

export default withTranslation(WycieczkaFakultatywna);
